// extracted by mini-css-extract-plugin
export default {"row":"styles_row__NytMU","w5":"styles_w5__6jNKo","w10":"styles_w10__uTEER","w15":"styles_w15__kuQvy","w20":"styles_w20__VnyLk"};